<template>
    <div id="app">
        <app-Menu></app-Menu>
        <app-Image></app-Image>
		<app-Language></app-Language>
        
        <div class='container'>
            <router-link :to="'/'"><div class ="logoL">
                <img src="./img/logo.png">
            </div></router-link>
            <router-view/>
        </div>
    </div>
</template>

<script>
import Menu from './components/Menu'
import PopImage from './components/PopImage' 
import PopLanguage from './components/PopLanguage' 
  
export default {
    name: 'App',
    data: () => ({
        errors: [],
    }),
    components: {
        'app-Menu': Menu,
        'app-Image': PopImage,
		'app-Language': PopLanguage,
        
    }
}
</script>

<style>
    #app {
      font-family: 'Avenir', Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-align: center;
      color: #2c3e50;
      --margin-top: 60px;
    }
    body{
        background-image:url('./img/ff1.jpg');
        background-repeat:repeat-x;
        background-attachment: fixed;
        background-color: #ffffff;
        padding-top: 20px;
    }
    @media screen and (max-width: 1140px) {
        body {
            padding-top: 0px;
        }
    }
    @font-face {
        font-family: AdLib;
        src: url(fonts/AdLib.ttf);
    }
    a, a:visited {
        color: #ab4542 !important;
        font-weight: bold;
        text-decoration: none;
        cursor: pointer;
    }
    a:hover, a:active {
        color: #d9534f !important;
        text-decoration: none !important;
        cursor: pointer;
    }
    
    .navback {
    background: rgba(255,255,255, 0);
    border: 0;
    }


    .navtop {
    background: rgba(255,255,255, 0.4);
    border: 0;
    }
    .contentWrapper {
        margin-right: 0px;
        margin-left: 0px;        
    }

    .contentBlock {
        width: 100%;
        min-height: 190px;
        margin: auto;
        margin-top: 15px;
        margin-bottom: 25px;
        padding: 0px; /* Поля вокруг текста */
        border: 30px solid #ffffff;
        border-image: url('img/win.png') 50 stretch;
        border-image-outset: 10px;
        background-color: rgba(102, 153, 204, 0.4);
        filter: alpha(Opacity=40); /* Прозрачность в IE */
    }
    .contentBlock p {
        color: #black;
        text-align: justify;
        text-indent: 15px;
        line-height: 1.4;
    }
    .logoL {
        margin-right: -8px;
        margin-left: -8px;  
        margin-bottom: 10px;
        padding: 0;
        height: auto;
    }
    .logoL img {
        width: auto;
        height: auto;
        opacity: 1;
    }
    .logoL img:hover {
        opacity: 0.8;
    }    
    .btn-discord {
        color: #fff;
        background-color: #738adb;
        border-color: #738adb;
    }
    .btn-discord:hover {
        color: #fff;
        background-color: #6175bc;
        border-color: #6175bc;    
    }
    .btn-vk {
        color: #fff;
        background-color: #4a76a8;
        border-color: #4a76a8;
    }
    .btn-vk:hover {
        color: #fff;
        background-color: #3a6595;
        border-color: #3a6595;    
    }    
    
    .btn-icon {
        font-size: 18px;
        margin-right: 10px;
        margin-top: -4px;
        margin-bottom: -4px;
    }
    .btn, btn:visited {
        color: #ffffff !important;
        text-decoration: none;
    }
    .btn:hover, btn:active {
        color: #ffffff !important;
        text-decoration: none;
    }
    .affix {
      top: 50px;
      width:100%;
    }



	.badge:hover {
	  color: #ffffff;
	  text-decoration: none;
	  cursor: pointer;
	}
	.badge-weapons {
	  background-color: #b94a48 !important;
	}
	.badge-weapons:hover {
	  background-color: #953b39;
	}
	.btn-weapons {
		color: #fff;
		background-color: #b94a48;
		border-color: #953b39;
		margin-bottom: 10px !important;
	}	
	
	.badge-warning {
	  background-color: #f89406 !important;
	}
	.badge-warning:hover {
	  background-color: #c67605;
	}
	
	.badge-skins {
	  background-color: #ffc107 !important;
	}
	.badge-skins:hover {
	  background-color: #b68b0b;
	}
	.btn-skins {
		color: #fff;
		background-color: #ffc107;
		border-color: #b68b0b;
		margin-bottom: 10px !important;
	}	
	
	.badge-clothes {
	  background-color: #e16d11 !important;
	}
	.badge-clothes:hover {
	  background-color: #a15112;
	}
	.btn-clothes {
		color: #fff;
		background-color: #e16d11;
		border-color: #a15112;
		margin-bottom: 10px !important;
	}	
	

	.badge-maps {
	  background-color: #468847 !important;
	}
	.badge-maps:hover {
	  background-color: #356635;
	}
	.btn-maps {
		color: #fff;
		background-color: #468847;
		border-color: #356635;
		margin-bottom: 10px !important;
	}		
	
	.badge-gameModes {
	  background-color: #3a87ad !important;
	}
	.badge-gameModes:hover {
	  background-color: #2d6987;
	}
	.btn-gameModes {
		color: #fff;
		background-color: #3a87ad;
		border-color: #2d6987;
		margin-bottom: 10px !important;
	}	
	
	.badge-inverse {
	  background-color: #333333 !important;
	}
	.badge-inverse:hover {
	  background-color: #1a1a1a;
	}
	.btn-all {
		color: #fff;
		background-color: #333333;
		border-color: #1a1a1a;
		margin-bottom: 10px !important;
	}	
	
	.badge-missions {
	  background-color: #6f42c1 !important;
	}
	.badge-missions:hover {
	  background-color: #432777;
	}
	.btn-missions {
		color: #fff;
		background-color: #6f42c1;
		border-color: #432777;
		margin-bottom: 10px !important;
	}

	.badge-other {
	  background-color: #777777 !important;
	}
	.badge-other:hover {
	  background-color: #432777;
	}
	.btn-other {
		color: #fff;
		background-color: #777777;
		border-color: #432777;
		margin-bottom: 10px !important;
	}


    .filler{
      min-height: 2000px;
    }

    .content-row {
    }
    .content-div {
        padding-right: 0.25em;
        padding-left: 0.25em;
        padding-bottom: 1em;
    //padding: 0;
    }



    .content-row .content-div:last-child {
      //padding-right: 0 !important;
    }
    .content-block .image {
      display: inline-block;
      float: left;
      width: 40%;
      height: 150px;
      background-size: cover;
      background-position: center center;
    }
    .content-block:hover .image {
      opacity: 0.8;
    }
    .content-block  .content {
      padding: 0.5em;
    }
    .content-block  .news-content {
      display: inline-block;
      width: 60%;
      height: 150px;
      padding: 0.5em;
    }
    .content-block  .news-content .title{
      height: 100px !important;
    }
    .content-block:hover {
      -moz-box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.1);
      box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.1);
    }
    .content-block .image, .content-block   .news-content {
      display: inline-block;
      position: relative;
      -moz-transition: all 500ms ease;
      -o-transition: all 500ms ease;
      -webkit-transition: all 500ms ease;
      transition: all 500ms ease;
    }
    ul, ol {
        text-align: left;
    }
    .logo {
	max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/App.vue